var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// api/buchung-filter.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
import { DateTime } from "luxon";
var BuchungFilter = class extends AdornisFilter {
  constructor(doc) {
    super(doc);
  }
  getMongoFilter() {
    const orig = super.getMongoFilter();
    if (this.filterBy === "belegdatum")
      throw new Error("dont support belegdatum yet");
    if ((this.from || this.until) && !this.filterBy)
      throw new Error("have to set filterBy if using from / until");
    return {
      $and: [
        orig,
        ...this.from || this.until ? this.filterBy === "buchungsdatum" ? [{ buchungsDatum: { $gte: this.from ?? void 0, $lte: this.until ?? void 0 } }] : [
          /** // TODO  */
        ] : [],
        ...this.kostenstelle ? [{ "kostenstellen.kostenstelle": this.kostenstelle }] : []
      ]
    };
  }
};
BuchungFilter._class = "BuchungFilter";
__decorateClass([
  Field((type) => String, { default: (v) => v ?? "buchungsdatum" })
], BuchungFilter.prototype, "filterBy", 2);
__decorateClass([
  Field((type) => DateTime)
], BuchungFilter.prototype, "from", 2);
__decorateClass([
  Field((type) => DateTime)
], BuchungFilter.prototype, "until", 2);
__decorateClass([
  Field((type) => String)
], BuchungFilter.prototype, "kostenstelle", 2);
BuchungFilter = __decorateClass([
  Entity()
], BuchungFilter);
export {
  BuchungFilter
};
